import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import Text from 'components/text/text';
import GridCol from 'components/grid/grid-col';
import GridRow from 'components/grid/grid-row';
import ScrollLink from 'components/scroll-link';
import Icon from 'components/icons/icon';

export default class Hero extends React.Component {
  constructor (props) {
    super(props);
  }

  _renderSubText() {
    return (
      <Text
        color={this.props.serverError ? 'DefaultOrange' : 'DefaultGray'}
        height="medium"
        tag="p"
        type="md"
        weight="normal"
        >
        {this.props.supportingTxt}
      </Text>
    );
  }

  _renderTertiaryText() {
    return !this.props.tertiaryText ? '' : (
      <div className="set-bd set-bd_detached mix-set_constrained">
        <Text
          color="DefaultGray"
          height="medium"
          tag="p"
          type="md"
          weight="normal"
          >
          {this.props.tertiaryText}
        </Text>
      </div>
    )
  }

  _renderScrollTo() {
    return !this.props.scrollTo ? '' : (
      <div className="set-bd set-bd_detached mix-set_constrained">
        <ScrollLink className="hero-scroller" target={this.props.scrollTo}>
          <Icon
            fillColor="DefaultBlue"
            iconSize="lg"
            iconType="chevron"
            className="icon-chevron_down"
          />
        </ScrollLink>
      </div>
    )
  }

  _renderTextContent() {
    return (
      <div className="set">
        <div className="set-hd">
          <Text tag="h1" type="huge" color="Lightest">
            {this.props.title}
          </Text>
        </div>
        <div className="set-bd set-bd_detached mix-set_constrained">
          {this._renderSubText()}
        </div>
        {this._renderTertiaryText()}
        {this._renderScrollTo()}
      </div>
    )
  }

  _renderMainContent() {
    const textContent = this._renderTextContent();
    let mainContent = textContent;

    if (this.props.aside !== undefined) {
      mainContent = (
        <GridRow className="mix-grid_vertCenter">
          <GridCol
            className="cell_separatedSm cell_separatedMd"
            phone="4"
            tablet="8"
            tabletLg="4"
            desktop="7"
          >
            {textContent}
          </GridCol>
          <GridCol
            className="cell_separatedSm cell_separatedMd"
            phone="4"
            tablet="8"
            tabletLg="4"
            desktop="5"
          >
            {this.props.aside}
          </GridCol>
        </GridRow>
      )
    }

    return mainContent;
  }

  _renderActions() {
    return !this.props.children ? '' : (
      <div className="hero-actions">
        <div className="container">
          {this.props.children}
        </div>
      </div>
    )
  }

  render() {
    const mainContent = this._renderMainContent();
    const actions = this._renderActions();

    return (
      <section className="hero">
        <div className="hero-content">
          <div className="container">
            {mainContent}
          </div>
        </div>
        {actions}
      </section>
    );
  }
}

Hero.propTypes = {
  'aside': PropTypes.node,
  'scrollTo': PropTypes.string,
  'serverError': PropTypes.bool,
  'supportingTxt': PropTypes.string,
  'tertiaryText': PropTypes.string,
  'title': PropTypes.string
};



// WEBPACK FOOTER //
// ./src/client/components/heroes/hero.jsx